export const SPECIALTY_CERT_ROUTE_NAME = 'specialtyCertRoutes';
export const SPECIALTY_CERT_BY_SPECIALTY_ROUTE_NAME = 'specialtyCertBySpecialty';

export const SPECIALTY_CERT_ROUTES = {
  get: 'specialty-certifications/{specId}',
};

export const SPECIALTY_CERT_BY_SPECIALTY_ROUTES = {
  get: 'specialty-certifications/by-specialty/{specialtyId}',
};
